import { render, staticRenderFns } from "./role-list.vue?vue&type=template&id=9e322638&scoped=true&"
import script from "./role-list.vue?vue&type=script&lang=js&"
export * from "./role-list.vue?vue&type=script&lang=js&"
import style0 from "./role-list.vue?vue&type=style&index=0&id=9e322638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e322638",
  null
  
)

export default component.exports